<template>
  <div class="mt-20">
    <el-form  :model="post" :rules="rules" ref="post" label-width="120px" >
      <el-form-item label="微页介绍" prop="join_introduce">
        <el-input type="textarea" v-model="post.join_introduce" placeholder="微页介绍" class="w-500"  :rows="6"></el-input>
      </el-form-item>
      <el-form-item label="使用说明" prop="usage">
        <el-input type="textarea" v-model="post.usage" placeholder="使用说明" class="w-500"  :rows="8"></el-input>
      </el-form-item>
      <el-form-item label="服务条款" prop="server_introduce">
        <el-input type="textarea" v-model="post.server_introduce" placeholder="服务条款" class="w-500"
                  :rows="18"></el-input>
      </el-form-item>
<!--      <el-form-item label="展示图片" prop="image">
        <vue-upload v-model="post.image"></vue-upload>
      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="set_rule">确定提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import FEdit from '@/components/form/f-edit';
// import VueUpload from "@/components/upload/upload.vue";
export default {
  name: "rule",
  components:{},
  data(){
    return{
      rules : {
        join_introduce : [{required:true, message : '请填写', trigger:'blur'}],
        server_introduce : [{required:true, message : '请填写', trigger:'blur'}],
        usage : [{required:true, message : '请填写', trigger:'blur'}],
        image : [{required:true, message : '请上传', trigger:'blur'}],
      },
      post:{
      },
    }
  },
  mounted:async function(){
    try {
      await this.get_data();
    }catch (e) {
      console.log(e);
    }
  },
  methods:{
    get_data:async function (){
      this.$_showLoading();
      let res = await this.$_api.setting('config',{type:'introduce'});
      this.$_hideLoading();
      if(res.errcode == 0){
        this.post = res.data.content;
      }
    },
    set_rule:async function (){
      this.$_showLoading();
      let res = await this.$_api.setting('config_update', {type:'introduce',content:this.post});
      this.$_hideLoading();
      this.$_showToast(res.errmsg,res.style);
      if(res.errcode == 0) {
        await this.get_data();
      }
    }
  }
}
</script>

<style scoped>

</style>